import _get from 'lodash-es/get';

export const getCDN = url => `https://b.zmtcdn.com${url}`;

export const getCroppedUrl = (url, width, height, factor = 2) => {
  const fWidth = width * factor;
  const fHeight = height * factor;
  const hasParams = url.indexOf('?') >= 0;
  const cropParam = `fit=around|${fWidth}:${fHeight}&crop=${fWidth}:${fHeight};*,*`;
  return hasParams ? `${url}&${cropParam}` : `${url}?${cropParam}`;
};

export const isNonEmptyArray = arrayName =>
  Array.isArray(arrayName) && !!arrayName.length;

export const isUserLoggedIn = store => {
  let numericUserId = Number(_get(store, 'user.user_id', 0));
  numericUserId = Number.isNaN(numericUserId) ? 0 : numericUserId;
  const name = _get(store, 'user.name', '');
  // const email = _get(store, 'user.email', '');
  return Boolean(numericUserId && name);
};

export const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validateName = name => {
  const re = /^[a-zA-Z0-9 ()@-]+$/;
  return re.test(String(name).toLowerCase());
};
